export const useFormStore = defineStore('form', {
  state: () => ({
    showSlidePanel: false,
    isDirty: false,
    showConfirm: false,
    openRadixOverlayCount: 0,
  }),
  getters: {
    hasOpenRadixOverlay: (state) => state.openRadixOverlayCount > 0,
  },
  actions: {
    show() {
      this.showSlidePanel = true
    },
    setDirty(bool: boolean) {
      this.isDirty = bool
    },
    reset() {
      this.showSlidePanel = false
      this.isDirty = false
      this.showConfirm = false
    },
    hide() {
      this.showSlidePanel = false
    },
    cancel() {
      if (!this.isDirty) {
        this.reset()
        return
      }
      this.showConfirm = true
    },
    cancelConfirm() {
      this.showConfirm = false
    },
    registerRadixOverlay() {
      this.openRadixOverlayCount += 1
    },
    unregisterRadixOverlay() {
      this.openRadixOverlayCount = Math.max(0, this.openRadixOverlayCount - 1)
    },
  },
})
